import React from 'react';

function Timestamp() {
  return(
    <span>Last updated: </span>
  )
}

export default Timestamp